import { GHLLanguageKeys as t } from "./ghl-ui.es285.js";
import a from "./ghl-ui.es833.js";
const i = {
  name: t.italian,
  locale: a
};
export {
  i as date_it
};
